import OrderCargoOrderFinishedListRequest, {
  OrderCargoOrderFinishedListRequestQueryParams,
} from "./order-cargo-order-finished-list.request";

const createQueryParams = (
  data: OrderCargoOrderFinishedListRequest,
): OrderCargoOrderFinishedListRequestQueryParams => {
  return {
    client: data.client,
    dispatch: data.dispatch,
    driver: data.driver,
    passenger: data.passenger,
    taxi: data.taxi,
    externalId: data.externalId,
    isApproved: data.isApproved,
    isCancelled: data.isCancelled,
    limit: data.limit,
    address: data.address,
    startAddress: data.startAddress,
    midAddress: data.midAddress,
    endAddress: data.endAddress,
    publicStatus: data.publicStatus,
    offset: data.offset,
    order: data.order,
    startTimeSince: data.startTimeSince,
    startTimeTo: data.startTimeTo,
    humanId: data.internalOrderId,
    fleetPartners: data.fleetPartners,
    excludeFleetPartners: data.excludeFleetPartners,
  };
};

const orderCargoOrderFinishedListRequestFactory = {
  createQueryParams,
};

export default orderCargoOrderFinishedListRequestFactory;
